<template>
  <ui-dialog
    :show="isOpen"
    persistent
    scrollable
    max-width="623"
    @input="close"
    custom-class="mass-facilities-edit-labels-delete-dialog"
  >
    <template #header>
      <h3 class="heading">
        {{ $t("message.facilityDetails.labels.deleteLabels") }}
      </h3>
      <p class="description">
        {{ $t("message.facilityDetails.labels.deleteLabelsDescription") }}
      </p>
      <v-text-field
        v-model="labelSearchInputValue"
        :placeholder="$t('message.facilityDetails.labels.findLabels')"
        prepend-inner-icon="icon-search"
        clearable
        outlined
        rounded
        class="mt-4"
        :hide-details="true"
      ></v-text-field>
    </template>
    <template #default>
      <div class="delete-labels">
        <v-list v-if="filteredLabels.length">
          <v-virtual-scroll
            :items="filteredLabels"
            :item-height="listItemHeight"
            :height="listHeight"
          >
            <template v-slot:default="{ item }">
              <v-list-item
                :key="item.id"
                :ripple="false"
                @click="toggleLabel(item)"
                class="list-item"
                :class="{ selected: item.isSelected }"
              >
                <v-list-item-content class="d-flex align-center">
                  <v-icon
                    size="21"
                    :color="item.isSelected ? 'pink' : 'text'"
                    class="mr-3"
                  >
                    {{ item.isSelected ? "icon-trash" : "icon-plus" }}
                  </v-icon>
                  <p class="list-item__name">{{ item.value }}</p>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-virtual-scroll>
        </v-list>
        <no-data v-else></no-data>
      </div>
      <SectionLoader :status="loadingList" />
    </template>
    <template #actions>
      <ui-button outlined @click="close">
        {{ $t("message.common.close") }}
      </ui-button>
      <ui-button color="primary" @click="handleDelete">
        {{ $t("message.common.apply") }}
      </ui-button>
    </template>
  </ui-dialog>
</template>

<script>
import cuid from "cuid";
import facilitiesService from "@/services/facilities";

import { gmbLabelsDialogsLogic as labelsDialogLogicMixin } from "@/helpers/mixins/gmb-labels-dialogs-logic";

export default {
  name: "GmbLabelsDeleteDialog",
  mixins: [labelsDialogLogicMixin],
  props: {
    facilitiesIds: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    async isOpen(newValue) {
      if (newValue) {
        this.loadingList = true;

        const response = await facilitiesService.fetchFacilitiesLabelsByIds(
          this.facilitiesIds.map(id => +id)
        );

        if (response && response.data) {
          this.labels = response.data.map(label => {
            return {
              id: cuid(),
              value: label,
              isSelected: false
            };
          });
        }

        if (this.initiallySelectedLabels.length > 0) {
          this.setInitialLabels();
        }

        this.loadingList = false;
      } else {
        this.labelSearchInputValue = "";
        this.labels = [];
      }
    }
  },
  methods: {
    handleDelete() {
      this.$emit(
        "delete",
        this.selectedLabels.map(label => label.value)
      );
      this.close();
    }
  }
};
</script>

<style lang="scss" scoped>
.heading {
  line-height: 36px;
}

.description {
  @include font-size(14px);
  color: $text;
  opacity: 0.4;
  line-height: 20px;
}

.delete-labels {
  border-top: 1px solid $gray-200;
  padding-top: $spacing;
  margin-top: $spacing * 0.5;
  margin-bottom: $spacing * 3;
  display: flex;
  flex-direction: column;
  overflow-y: auto;

  .v-list-item {
    &__content {
      * {
        flex: unset;
      }
    }
  }
}

.list-item {
  height: 46px;
  border: 1px solid $text;
  border-radius: 30px;
  overflow: hidden;
  @include font-size(14px);
  border: 1px solid rgba($text, 0.14);
  transition: all 0.15s ease-in;
  margin-right: $spacing;

  &__name {
    margin-bottom: 0;
  }

  &.selected {
    border-color: $pink;
    background-color: $pink-light;
  }
}
</style>

<style lang="scss">
.mass-facilities-edit-labels-delete-dialog {
  .v-card {
    & > .v-card__title {
      padding-bottom: 0 !important;
    }
  }
}
</style>
